import { ProjectType } from './types'

export const PROJECTS: ProjectType[] = [
  {
    id: 'festivals',
    title: {
      key: 'projectTitleFestivals',
      default: 'Festivals'
    },
    category: {
      key: 'categoryInnovatie',
      default: 'Innovatie'
    },
    description: {
      key: 'projectDescriptionFestivals',
      default:
        'Deze zomer herneemt Bolt z’n ambitie om de festivals dieselvrij te maken. Dankzij een mobiele zonnepaneleninstallatie en stroom van lokale energieopwekkers draaien onder andere Werchter Parklife en Camping Belgica volledig op streekstroom.'
    },
    linkKey: 'projectFestivals',
    image: 'festivals.jpg'
  },
  {
    id: 'camping-belgica',
    title: {
      key: 'projectTitleCampingBelgica',
      default: 'Camping Belgica 2020'
    },
    category: {
      key: 'categoryInnovatie',
      default: 'Innovatie'
    },
    description: {
      key: 'projectDescriptionCampingBelgica',
      default:
        'Met uitzendingen vanop Camping Belgica zorgde StuBru een hele zomer lang voor de beste tunes. Dit summer-en coronaproof evenement draaide volledig op groene stroom in plaats van op vervuilende dieselgenerators.'
    },
    linkKey: 'projectCampingBelgica',
    image: 'camping-belgica.jpg'
  },
  {
    id: 'eva-de-roo',
    title: {
      key: 'projectTitleEvaDeRoo',
      default: 'Eva De Roo'
    },
    category: {
      key: 'categoryAmbassadeur',
      default: 'Ambassadeur'
    },
    description: {
      key: 'projectDescriptionEvaDeRoo',
      default:
        "Eva de Roo is trotse energie-afnemer én ambassadeur bij Bolt. Onder het motto 'weet wie je stroom opwekt' ging ze eten op het zonnepanelendak van opwekkers Ken en Kristof. Een avond vol verrassingen!"
    },
    linkKey: 'projectEvaDeRoo',
    image: 'eva-de-roo.jpg'
  },
  {
    id: 'brussels-beer-project',
    title: {
      key: 'projectTitleBrusselsBeerProject',
      default: 'Brussels Beer Project'
    },
    category: {
      key: 'categorySamenwerking',
      default: 'Samenwerking'
    },
    description: {
      key: 'projectDescriptionBrusselsBeerProject',
      default:
        'Als energie-afnemer én -opwekker staat Brussels Beer Project volledig achter onze missie. In januari 2021 lanceerden we samen een campagne om ook bierliefhebbers te overtuigen van Bolt, met een gratis Circular Beer Box.'
    },
    linkKey: 'projectBrusselsBeerProject',
    image: 'brussels-beer-project.jpg'
  },
  {
    id: 'iceland',
    title: {
      key: 'projectTitleIceland',
      default: 'IJsland'
    },
    category: {
      key: 'categoryStopSjoemelstroom',
      default: 'Stop sjoemelstroom'
    },
    description: {
      key: 'projectDescriptionIceland',
      default:
        'In de zomer van 2020 gaf Bolt-afgevaardigde Koen 1.000 groene stroomcertificaten terug aan de eerste minister van IJsland, zodat ze niet meer gebruikt konden worden om Belgische contracten groen te kleuren.'
    },
    linkKey: 'projectIceland',
    image: 'iceland.jpg'
  }
]
